// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AccordionController from "./accordion_controller";
application.register("accordion", AccordionController);

import AddressAutocompleteController from "./address_autocomplete_controller";
application.register("address-autocomplete", AddressAutocompleteController);

import AmountVarianceController from "./amount_variance_controller";
application.register("amount-variance", AmountVarianceController);

import AttachmentController from "./attachment_controller";
application.register("attachment", AttachmentController);

import AttachmentsController from "./attachments_controller";
application.register("attachments", AttachmentsController);

import AutofocusController from "./autofocus_controller";
application.register("autofocus", AutofocusController);

import BulkInviteController from "./bulk_invite_controller";
application.register("bulk-invite", BulkInviteController);

import CheckboxesController from "./checkboxes_controller";
application.register("checkboxes", CheckboxesController);

import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);

import DanglingSpiderController from "./dangling_spider_controller";
application.register("dangling-spider", DanglingSpiderController);

import DatalistController from "./datalist_controller";
application.register("datalist", DatalistController);

import DelightController from "./delight_controller";
application.register("delight", DelightController);

import DropdownController from "./dropdown_controller";
application.register("dropdown", DropdownController);

import DropzoneController from "./dropzone_controller";
application.register("dropzone", DropzoneController);

import ElementRemovalController from "./element_removal_controller";
application.register("element-removal", ElementRemovalController);

import EquipmentPickController from "./equipment_pick_controller";
application.register("equipment-pick", EquipmentPickController);

import ExternalCustomerAutocompleteController from "./external_customer_autocomplete_controller";
application.register("external-customer-autocomplete", ExternalCustomerAutocompleteController);

import FieldsForController from "./fields_for_controller";
application.register("fields-for", FieldsForController);

import FileDropController from "./file_drop_controller";
application.register("file-drop", FileDropController);

import FileUploadController from "./file_upload_controller";
application.register("file-upload", FileUploadController);

import FinancingController from "./financing_controller";
application.register("financing", FinancingController);

import FormController from "./form_controller";
application.register("form", FormController);

import IntegratedControlController from "./integrated_control_controller";
application.register("integrated-control", IntegratedControlController);

import LoaderController from "./loader_controller";
application.register("loader", LoaderController);

import ModalController from "./modal_controller";
application.register("modal", ModalController);

import MoneyInputController from "./money_input_controller";
application.register("money-input", MoneyInputController);

import NameplateEvaluationController from "./nameplate_evaluation_controller";
application.register("nameplate-evaluation", NameplateEvaluationController);

import NavigationController from "./navigation_controller";
application.register("navigation", NavigationController);

import OriginalCoolingSystemController from "./original_cooling_system_controller";
application.register("original-cooling-system", OriginalCoolingSystemController);

import PinController from "./pin_controller";
application.register("pin", PinController);

import PlaceholderController from "./placeholder_controller";
application.register("placeholder", PlaceholderController);

import PollController from "./poll_controller";
application.register("poll", PollController);

import ProjectArchiveFormController from "./project_archive_form_controller";
application.register("project-archive-form", ProjectArchiveFormController);

import ProjectSearchController from "./project_search_controller";
application.register("project-search", ProjectSearchController);

import QuestionnaireController from "./questionnaire_controller";
application.register("questionnaire", QuestionnaireController);

import QuestionnaireItemController from "./questionnaire_item_controller";
application.register("questionnaire-item", QuestionnaireItemController);

import RangeSliderController from "./range_slider_controller";
application.register("range-slider", RangeSliderController);

import ScrollToController from "./scroll_to_controller";
application.register("scroll-to", ScrollToController);

import SearchResultsController from "./search_results_controller";
application.register("search-results", SearchResultsController);

import SidebarController from "./sidebar_controller";
application.register("sidebar", SidebarController);

import SingleFileUploadController from "./single_file_upload_controller";
application.register("single-file-upload", SingleFileUploadController);

import StripeBankAccountController from "./stripe_bank_account_controller";
application.register("stripe-bank-account", StripeBankAccountController);

import StripeFinancialConnectionsController from "./stripe_financial_connections_controller";
application.register("stripe-financial-connections", StripeFinancialConnectionsController);

import SystemDetailsController from "./system_details_controller";
application.register("system-details", SystemDetailsController);

import SystemsController from "./systems_controller";
application.register("systems", SystemsController);

import ThumbnailController from "./thumbnail_controller";
application.register("thumbnail", ThumbnailController);

import ToggleController from "./toggle_controller";
application.register("toggle", ToggleController);

import TooltipController from "./tooltip_controller";
application.register("tooltip", TooltipController);

import TriggerController from "./trigger_controller";
application.register("trigger", TriggerController);
